import { useEffect } from 'react';
import sha1 from 'sha1';
import { v4 } from 'uuid';
import { useAppDispatch, useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { GeneralSlice } from '@/redux/general';
import { UserFormSlice } from '@/redux/user-form';
import Condition from '@/utils/condition';
import { useLocalStorage } from 'usehooks-ts';

const useGenerateLeadId = () => {
  const dispatch = useAppDispatch();
  const method = useAppSelector(ConfigSlice.selectors.externalIdGenerateMethod);
  const prefixConditioned = useAppSelector(ConfigSlice.selectors.prefix);
  const email = useAppSelector(UserFormSlice.selectors.email);
  const [, setIdentifier] = useLocalStorage<string>('identifier', '', {
    serializer: (value) => value, // store raw string without ""
    deserializer: (value) => value, // read raw string, can be used directly
  });

  const generateLeadId = (): string => {
    const prefix = Condition.getFirst(prefixConditioned, '');
    switch (method) {
      case 'sha1':
        // Example SWEdb076fc4608d0f8e5e7ea3cea6a7ce27301fa422
        return prefix + sha1(email + Date.now() + Math.random());
      case 'uuid':
        // Example SWEb66f20b4-082f-4276-81d2-34f034b8a1d1
        return prefix + v4();
    }
  };

  useEffect(() => {
    const externalId = generateLeadId();
    dispatch(GeneralSlice.actions.setLeadId(externalId));
    /*
     * We need to store the identifier in local storage because advertisers like
     * Facebook and Google require a consistent identifier to track conversions.
     */
    setIdentifier(externalId);
  }, []);
};

export default useGenerateLeadId;
